<template>
<div class="row align-center pesquisaonline"
    id="bolsasdeestudo"
    :style="{ backgroundImage: `url('${pesquisaonline}')`,}">
  <div class="columns small-12 medium-12 large-9">
      <HomeSectionTitle
        class="hst"
        :title="$t('UMA_LANG_SASUMA_HOME_BOLSAS')" />
      <div class="bolsalist">
        <div class="pesquisaonlineitem" v-for="bolsa in bolsas">
          <router-link 
            :to="{path: `/bolsasdeestudo/${bolsa.Name}`}"
            class="content">
              <p>{{bolsa.Titulo}}</p>
              <span>{{bolsa.Descricao}}</span>
          </router-link>
        </div>
      </div>  
      <router-link to="/bolsasdeestudo" class="morelinks">
          <i class="fa fa-plus-square-o"></i>{{ $t("UMA_LANG_SASUMA_VERMAIS")}}
      </router-link>
  </div>
</div>
</template>

<script>
import { ref } from "vue";
import pesquisaonline from "@/assets/images/pesquisaonline.jpg";
import HomeSectionTitle from "@/components/HomeSectionTitle.vue";
import axios from "@/axios";
import { i18n } from '@/main.js';


export default {
  components:{
    HomeSectionTitle
  },
  setup () {
    
    const bolsas = ref([])

    const lang = i18n.global.locale;

    const getBolsas = () => {
      axios.get(`/bolsassas?idioma=${lang}`).then(response => {
        bolsas.value = response.data;
      }).catch(error => {
        console.log(error);
      })
    }

    getBolsas();

    return {
      bolsas,
      pesquisaonline
    }
  }
}
</script>

<style>
.hst{
  --title-color: white;
}
</style>

<style lang="scss" scoped>
.bolsalist{
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-gap: 30px;
}

@media only screen and (min-width: 1280px) and (max-width: 1439px) {
  .bolsalist{
    grid-template-columns: repeat(3, 1fr);
  }
}

@media only screen and (max-width: 1279px) {
  .bolsalist{
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 15px;
  }
}

@media only screen and (max-width: 676px) {
  .bolsalist{
    grid-template-columns: repeat(1, 1fr);
    grid-gap: 15px;
  }
}

.pesquisaonline {
  position: relative;
  z-index: 0;
  padding-bottom: 180px;
  background-size: cover;
}

.pesquisaonline::after{
  -webkit-transition: opacity .5s ease-in-out;
    transition: opacity .5s ease-in-out;
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgb(14,92,114,0.52);
}

.pesquisaonline .columns{
  z-index: 1;
}

.pesquisaonline .morelinks{
  font-family: 'Montserrat Bold';
  color: white;
  text-transform: uppercase;
  margin-top: 50px;
  display: flex;
  font-size: 15px;
  align-items: center;
}

.pesquisaonline .morelinks:hover{
    color: white;
}

.pesquisaonline .morelinks i{
    margin-right: 10px;
    font-size: 24px;
}


@media (min-width: 768px) and (max-width: 1280px) and (orientation: landscape) {
  /*.columns.pesquisaonlineitem {
    flex: 0 0 50%;
    max-width: 50%;
  }*/
}

.pesquisaonlineitem{
  border: 2px solid #9dd2f9;
}

.pesquisaonlineitem .content{
  padding: 30px 30px 60px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 15px;
  color: white;
}

.pesquisaonlineitem p{
  font-family: "Montserrat SemiBold";
  margin-bottom: 10px;
  font-size: 21px;
  color: #9dd2f9;
}

.pesquisaonlineitem span{
  font-family: "Montserrat";
  font-size: 15px;
  display: block;
  text-align: center;
}

.linksList{
  display: flex;
  flex-wrap: wrap;
}

.pesquisaonlineitem a p {
  text-align: center;
}

@media (max-width : 767px){
  .linksmodal{
    width: 100%;
  }


  .pesquisaonlineitem p {
    font-size: 16px;
  }

  .pesquisaonlineitem .content {
    padding: 10px 10px 20px;
  }

  .pesquisaonlineitem span {
    font-size: 14px;
  }

  .pesquisaonline {
      padding-bottom: 80px;
  }

  .noticiassection .morelinks {
      margin-left: -39px;
  }

  .pesquisaonline .morelinks {
      margin-top: 20px;
  }

  .pesquisaonline {
      padding-bottom: 60px;
  }
}

/*
@media only screen and (min-width: 1280px) and (max-width: 1439px) {
  .columns.pesquisaonlineitem {
      flex: 0 0 33.333333%;
      max-width: 33.333333%;
  }
}
*/

</style>